import { NgModule } from '@angular/core';
import { NcDocumentsComponent } from './nc-documents/nc-documents.component';
import {NcDocumentFormDialogComponent} from './nc-document-form-dialog/nc-document-form-dialog.component';
import {NcDocumentFormComponent} from './nc-document-form/nc-document-form.component';
import {NcUtilsModule} from 'nc-utils';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {NcDatatableModule} from 'nc-datatable';
import {NcButtonModule} from 'nc-button';
import {NcInputModule} from 'nc-input';
import {NcSelectModule} from 'nc-select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {NcSharedModule} from 'nc-shared';
import {NcFileUploadModule} from 'nc-file-upload';
import {FlexModule} from '@angular/flex-layout';

@NgModule({
  declarations: [
    NcDocumentsComponent,
    NcDocumentFormDialogComponent,
    NcDocumentFormComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    TranslateModule,
    NcSharedModule,
    NcUtilsModule,
    NcInputModule,
    NcSelectModule,
    NcDatatableModule,
    NcButtonModule,
    NcFileUploadModule,
    FlexModule
  ],
  exports: [NcDocumentsComponent]
})
export class NcDocumentsModule { }
